import { OrderApprovalService } from "./OrderApprovalService";

export type { IOrderApprovalService } from "./IOrderApprovalService";
export type { OrderApprovalDTO } from "./OrderApprovalDTO";

export const orderApprovalService = new OrderApprovalService();
